import { PoposedToTheSubCommittee4EditContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee4EditContainer";
export function PoposedToTheSubCommittee4EditPage() {

    return (
        <PoposedToTheSubCommittee4EditContainer />
    )
}




